import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { checkUser } from "../api/UserApi";
import { dynamicFailed } from "../hooks/useToast";
import { useUserDataContext } from "../context/UserDataContext";

const CallBackHandler = () => {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const navigate = useNavigate();
  const { setUserData } = useUserDataContext();

  useEffect(() => {
    const accessToken = params?.get("access_token") || "";
    localStorage.setItem("frcsit:access-token", accessToken);
    if (accessToken === null || accessToken === undefined) {
      return;
    }
    Promise.all([checkUser(accessToken)])
      .then(([userData]) => {
        setUserData(userData);
        userData?.data?.roles[0]?.name === "sa"
          ? navigate("/admin/dashboard")
          : navigate("/member/dashboard");
      })
      .catch(() => {
        dynamicFailed("Server Error");
      });
  }, [params, navigate, setUserData]);

  return null;
};

export default CallBackHandler;
